import {XHRBackend, Http, RequestOptions} from '@angular/http';
import { InterceptedHttp } from './http.interceptor';
import { AlertService } from './alert.service';
import { BusyService } from './busy.service';
import { UserFriendlyErrorService } from './user-friendly-error.service';
import { Router } from '@angular/router';

export function httpFactory(xhrBackend: XHRBackend
  , requestOptions: RequestOptions
  , alertService: AlertService
  , busyService: BusyService
  , userFriendlyErrorService: UserFriendlyErrorService
  , router: Router): Http {
  return new InterceptedHttp(xhrBackend, requestOptions, alertService, busyService, userFriendlyErrorService, router);
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/http.factory.ts